/* ============================================================
   GOD SELECTION XXX — Custom JS
   ============================================================ */

// ─── Drawer stacking: last-opened drawer appears on top ───────
// Cart drawer z-index: var(--xxx-z-cart-drawer, 101)
// Header (contains menu drawer) z-index: var(--xxx-z-header, 100)
// Whichever opens last gets z-index 103; the other gets 101/100.
(function drawerStacking() {
  const root = document.documentElement;

  function bringCartFront() {
    root.style.setProperty('--xxx-z-cart-drawer', '103');
    root.style.setProperty('--xxx-z-header', '100');
  }
  function bringMenuFront() {
    root.style.setProperty('--xxx-z-cart-drawer', '101');
    root.style.setProperty('--xxx-z-header', '103');
  }
  function resetStacking() {
    root.style.removeProperty('--xxx-z-cart-drawer');
    root.style.removeProperty('--xxx-z-header');
  }

  // Watch cart drawer active class
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    new MutationObserver(() => {
      if (cartDrawer.classList.contains('active')) {
        bringCartFront();
      } else if (!document.querySelector('#Details-menu-drawer-container[open]')) {
        resetStacking();
      }
    }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  // Watch menu drawer details[open]
  const menuDetails = document.querySelector('#Details-menu-drawer-container');
  if (menuDetails) {
    menuDetails.addEventListener('toggle', () => {
      if (menuDetails.open) {
        bringMenuFront();
      } else if (!cartDrawer?.classList.contains('active')) {
        resetStacking();
      }
    });
  }
})();

// ─── Card: resolve the current destination URL for a card ────
// Returns the variant URL if a swatch is active, otherwise the plain product URL.
function cardDestUrl(card) {
  const variantUrl = card.dataset.xxxVariantUrl;
  if (variantUrl) return variantUrl;
  const link = card.querySelector('.card__heading a');
  return link ? link.getAttribute('href') : null;
}

// ─── Color Swatch: image swap + variant URL update ───────────
// Click on .xxx-swatch → swap the card image, update active state,
// and store the variant URL on the card for image-click navigation.
document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.xxx-swatch');
  if (!swatch) return;

  const card = swatch.closest('.card-wrapper');
  if (!card) return;

  e.preventDefault();
  e.stopPropagation();

  // Update active dot
  card.querySelectorAll('.xxx-swatch').forEach(s => s.classList.remove('is-active'));
  swatch.classList.add('is-active');

  // Swap primary image
  const imgUrl = swatch.dataset.variantImage;
  if (imgUrl) {
    const img = card.querySelector('.xxx-card-img');
    if (img) {
      // Remove srcset/sizes so subsequent src changes always take effect
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = imgUrl;
    }
  }

  // Store variant URL on card so image click can navigate to correct variant
  const variantId = swatch.dataset.variantId;
  if (variantId) {
    const baseLink = card.querySelector('.card__heading a');
    const baseUrl = baseLink ? baseLink.getAttribute('href').split('?')[0] : '';
    const variantUrl = baseUrl + '?variant=' + variantId;
    card.dataset.xxxVariantUrl = variantUrl;
    // Also update heading links so keyboard / right-click open-in-tab works correctly
    card.querySelectorAll('.card__heading a').forEach(a => a.setAttribute('href', variantUrl));
  }
});

// ─── Card image click → navigate to (variant) product page ───
// The full-card ::after overlay is disabled via CSS (pointer-events:none).
// This handler restores click-to-navigate on the product image only.
document.addEventListener('click', function (e) {
  const img = e.target.closest('.xxx-card-img');
  if (!img) return;

  const card = img.closest('.card-wrapper');
  if (!card) return;

  const url = cardDestUrl(card);
  if (url) window.location.href = url;
});

// ─── Product card HOVER IMAGE ────────────────────────────────
// On hover, reveal a second image over the card:
//   1. If custom.hover_image metafield is set → show it (priority).
//   2. Otherwise → show the image AFTER the one currently displayed.
//      Follows colour-swatch selection (matches by URL path, ignoring the
//      width/version query). If the current image is the last → wrap to first.
// The overlay <img.xxx-card-hover-img> and data-* attrs are emitted by
// snippets/card-product.liquid only when a hover target exists.
(function () {
  if (window.__xxxCardHoverInit) return;
  window.__xxxCardHoverInit = true;

  // Normalise any image URL to its pathname so we can match the same image
  // regardless of origin/protocol (dev proxies CDN under localhost; prod uses
  // cdn.shopify.com) and ignore the ?v=…&width=… query entirely.
  function pathKey(url) {
    if (!url) return '';
    try {
      return new URL(url, window.location.href).pathname;
    } catch (err) {
      return url.split('?')[0];
    }
  }

  function computeHoverSrc(media, card) {
    // Priority 1: metafield hover image
    var mf = media.getAttribute('data-xxx-hover-image');
    if (mf) return mf;

    // Priority 2: next image after the one currently shown
    var list;
    try {
      list = JSON.parse(media.getAttribute('data-xxx-images') || '[]');
    } catch (err) {
      return null;
    }
    if (!list || list.length <= 1) return null;

    var primary = (card || media).querySelector('.xxx-card-img');
    var curKey = primary ? pathKey(primary.currentSrc || primary.src) : '';

    var idx = -1;
    for (var i = 0; i < list.length; i++) {
      if (pathKey(list[i]) === curKey) { idx = i; break; }
    }
    if (idx === -1) idx = 0; // current not found → treat as first

    var next = (idx + 1) % list.length;
    if (pathKey(list[next]) === curKey) return null; // would be the same image
    return list[next];
  }

  // Point the overlay at its computed hover target (next image / metafield).
  // Returns the overlay element, or null when there's nothing to show. Does
  // NOT reveal it — the caller decides when, via revealWhenLoaded().
  function primeHover(card) {
    var media = card.querySelector('[data-xxx-hover]');
    if (!media) return null;
    var overlay = media.querySelector('.xxx-card-hover-img');
    if (!overlay) return null;
    var src = computeHoverSrc(media, card);
    if (!src) return null;
    if (overlay.getAttribute('src') !== src) {
      overlay.classList.remove('is-shown'); // start hidden so it can fade in
      overlay.setAttribute('src', src);
    }
    return overlay;
  }

  // Reveal once the image has loaded — but only if `stillActive()` is still
  // true at that moment (pointer still over the card / finger still pressing).
  // Gating on load means the opacity fade always plays instead of popping in.
  function revealWhenLoaded(overlay, stillActive) {
    var go = function () { if (stillActive()) overlay.classList.add('is-shown'); };
    if (overlay.complete && overlay.naturalWidth > 0) go();
    else overlay.onload = go;
  }

  function hideHover(card) {
    var media = card.querySelector('[data-xxx-hover]');
    if (!media) return;
    var overlay = media.querySelector('.xxx-card-hover-img');
    if (overlay) overlay.classList.remove('is-shown'); // fades back out
  }

  function hoverAreaFrom(target) {
    if (!target || !target.closest) return null;
    var area = target.closest('.card__media');
    if (!area) return null;
    var card = area.closest('.card-wrapper');
    if (!card || !area.querySelector('[data-xxx-hover]')) return null;
    return { area: area, card: card };
  }

  // ── Mouse: hover-capable pointers (skip touch, which has no hover state) ──
  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function (e) {
      var hit = hoverAreaFrom(e.target);
      if (!hit) return;
      if (e.relatedTarget && hit.area.contains(e.relatedTarget)) return; // internal move
      var overlay = primeHover(hit.card);
      if (overlay) revealWhenLoaded(overlay, function () { return hit.area.matches(':hover'); });
    });
    document.addEventListener('mouseout', function (e) {
      var hit = hoverAreaFrom(e.target);
      if (!hit) return;
      if (e.relatedTarget && hit.area.contains(e.relatedTarget)) return; // still inside image area
      hideHover(hit.card);
    });
  }

  // ── Touch: reveal the card under the finger ──
  // While a finger is on the screen, the card directly beneath it shows its
  // next image — and as the page scrolls (or the finger slides), whichever
  // card passes under the finger reveals in turn. Lifting reverts. A tap still
  // navigates (the overlay is pointer-events:none).
  (function () {
    var activeCard = null;

    function cardAt(x, y) {
      var el = document.elementFromPoint(x, y);
      var hit = hoverAreaFrom(el);
      return hit ? hit.card : null;
    }

    function moveTo(card) {
      if (card === activeCard) return;
      if (activeCard) hideHover(activeCard); // revert the one we left
      activeCard = card;
      if (!card) return;
      var overlay = primeHover(card);
      if (overlay) revealWhenLoaded(overlay, function () { return activeCard === card; });
    }

    function end() {
      if (activeCard) hideHover(activeCard);
      activeCard = null;
    }

    document.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1 || !e.target.closest) return;
      var hit = hoverAreaFrom(e.target);
      moveTo(hit ? hit.card : null);
    }, { passive: true });

    document.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 1) return;
      var t = e.touches[0];
      moveTo(cardAt(t.clientX, t.clientY)); // follow the finger across cards
    }, { passive: true });

    document.addEventListener('touchend', end);
    document.addEventListener('touchcancel', end);
  })();
})();

// ─── Undefined swatch detection ──────────────────────────────
// Adds .swatch--undefined to any swatch whose color variable resolves
// to an unrecognised CSS colour name. Uses a hidden test element to
// probe the browser's colour parser: valid colours produce a non-empty
// computed style; invalid ones produce an empty string.
(function markUndefinedSwatches() {
  const probe = document.createElement('div');
  probe.style.display = 'none';
  document.body.appendChild(probe);

  function isValidColor(value) {
    if (value.startsWith('url(')) return true; // image swatch (PNG from files)
    probe.style.backgroundColor = '';
    probe.style.backgroundColor = value;
    return probe.style.backgroundColor !== '';
  }

  function scan() {
    // Product detail page: Dawn .swatch with --swatch--background
    document.querySelectorAll('.swatch[style]').forEach(el => {
      const val = el.style.getPropertyValue('--swatch--background').trim();
      if (val && !isValidColor(val)) el.classList.add('swatch--undefined');
      else el.classList.remove('swatch--undefined');
    });

    // Product cards: .xxx-swatch with --xxx-swatch-bg
    document.querySelectorAll('.xxx-swatch[style]').forEach(el => {
      const val = el.style.getPropertyValue('--xxx-swatch-bg').trim();
      if (val && !isValidColor(val)) el.classList.add('swatch--undefined');
      else el.classList.remove('swatch--undefined');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Re-scan when new content is injected (e.g. quick-add, recommendations)
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();

// ─── Cart Exclusivity Guard: LIMITED ORDER vs in-stock ────────
// 受注生産商品(タグ "LIMITED ORDER") と 通常在庫商品 を
// 同一カートに混在させない。混在しそうな add-to-cart を捕捉して
// 確認モーダルを出し、ユーザー同意で既存カートをクリア → 追加し直す。
//
// 識別方法: LIMITED ORDER 追加時に hidden line item property
//   `properties[_limited_order]=1` を付ける。`_` プレフィックスは
//   Shopify がカートUIから非表示にする慣習。
//
// 仕組み: capture-phase の submit リスナでフォームを捕捉し、
//   product-form 配下なら preventDefault → /cart.js 確認 → 判定 →
//   問題なければ form.requestSubmit() で本来のハンドラに引き渡す。
(function cartExclusivityGuard() {
  const LIMITED_TAG = 'limited order';
  const LIMITED_PROP = '_limited_order';
  const BYPASS_KEY = '__xxxGuardBypass';

  function isLimitedTags(tagsStr) {
    if (!tagsStr) return false;
    return tagsStr.split(',').some(t => t.trim().toLowerCase() === LIMITED_TAG);
  }

  function cartIsLimited(cart) {
    return (cart.items || []).some(item => item.properties && item.properties[LIMITED_PROP]);
  }

  function ensureLimitedProperty(form, isLimited) {
    form.querySelectorAll('input[data-xxx-limited-marker]').forEach(el => el.remove());
    if (!isLimited) return;
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[' + LIMITED_PROP + ']';
    input.value = '1';
    input.setAttribute('data-xxx-limited-marker', '');
    form.appendChild(input);
  }

  function resubmit(form) {
    form[BYPASS_KEY] = true;
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      // 旧ブラウザフォールバック
      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.click();
      else form.submit();
    }
  }

  function showModal(opts) {
    const addingLimited = opts.addingLimited;
    const existing = document.getElementById('xxx-cart-guard-modal');
    if (existing) existing.remove();

    const message = addingLimited
      ? 'こちらは受注生産商品のため、通常商品と同時にご注文いただけません。<br>カート内の通常商品を削除して、この受注生産商品を追加しますか?'
      : 'カート内に受注生産商品があります。<br>受注生産商品を削除して、こちらの商品を追加しますか?';

    const modal = document.createElement('div');
    modal.id = 'xxx-cart-guard-modal';
    modal.className = 'xxx-cart-guard__overlay';
    modal.innerHTML =
      '<div class="xxx-cart-guard__panel" role="dialog" aria-modal="true" aria-labelledby="xxx-cart-guard__title">' +
        '<h2 id="xxx-cart-guard__title" class="xxx-cart-guard__title">カートを切り替えますか?</h2>' +
        '<p class="xxx-cart-guard__message">' + message + '</p>' +
        '<div class="xxx-cart-guard__actions">' +
          '<button type="button" class="xxx-cart-guard__btn xxx-cart-guard__btn--secondary" data-action="cancel">キャンセル</button>' +
          '<button type="button" class="xxx-cart-guard__btn xxx-cart-guard__btn--primary" data-action="confirm">カートを切り替える</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(modal);
    document.body.classList.add('xxx-cart-guard-open');

    function close() {
      modal.remove();
      document.body.classList.remove('xxx-cart-guard-open');
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
    }

    modal.addEventListener('click', function (e) {
      if (e.target === modal) { close(); return; }
      const action = e.target.dataset && e.target.dataset.action;
      if (action === 'cancel') close();
      if (action === 'confirm') { close(); opts.onConfirm(); }
    });
    document.addEventListener('keydown', onKey);

    const focusBtn = modal.querySelector('[data-action="confirm"]');
    if (focusBtn) focusBtn.focus();
  }

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form || form.tagName !== 'FORM') return;

    // 自身による再送信はスルー
    if (form[BYPASS_KEY]) { delete form[BYPASS_KEY]; return; }

    const productForm = form.closest('product-form');
    if (!productForm) return;

    const addingLimited = isLimitedTags(productForm.dataset.productTags || '');

    // 非同期判定のため一旦遮断
    e.preventDefault();
    e.stopImmediatePropagation();

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        const hasItems = (cart.items || []).length > 0;
        const cartLimited = cartIsLimited(cart);
        const conflict = hasItems && (cartLimited !== addingLimited);

        if (!conflict) {
          ensureLimitedProperty(form, addingLimited);
          resubmit(form);
          return;
        }

        showModal({
          addingLimited: addingLimited,
          onConfirm: function () {
            fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
              .then(() => {
                ensureLimitedProperty(form, addingLimited);
                resubmit(form);
              })
              .catch(err => {
                console.error('[XXX Cart Guard] clear failed', err);
              });
          }
        });
      })
      .catch(err => {
        console.error('[XXX Cart Guard] cart fetch failed', err);
        // フォールバック: 判定失敗時はそのまま追加
        ensureLimitedProperty(form, addingLimited);
        resubmit(form);
      });
  }, true);
})();


/* ============================================================
   KEY VISUAL SLIDER (xxx-keyvisual-slider section)
   ============================================================
   Lightweight self-contained slider. No external deps.
   - dot indicators + touch swipe
   - optional autoplay (data-autoplay), pauses on hover/touch
   - plays only the active slide's video, pauses the rest
   - Shopify theme editor aware (block select / section load)
   ============================================================ */
(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // `root` is a single pane ([data-xxx-kvs-pane]); each pane is an independent
  // slider so desktop and mobile can carry a different number of slides.
  function XXXKeyVisualSlider(root) {
    this.root = root;
    var section = root.closest('[data-xxx-kvs]') || root;
    this.track = root.querySelector('[data-xxx-kvs-track]');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-xxx-kvs-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-xxx-kvs-dot]'));
    this.index = 0;
    this.count = this.slides.length;
    this.autoplay = section.hasAttribute('data-autoplay') && !prefersReduced;
    this.interval = parseInt(section.getAttribute('data-interval'), 10) || 5000;
    this.timer = null;

    if (!this.track || this.count <= 1) {
      this.playActiveVideo();
      return;
    }
    this.bind();
    this.goTo(0, true);
    this.start();
  }

  XXXKeyVisualSlider.prototype.goTo = function (i, instant) {
    this.index = (i + this.count) % this.count;
    if (instant) this.track.classList.add('is-dragging');
    this.track.style.transform = 'translate3d(' + (-this.index * 100) + '%, 0, 0)';
    if (instant) {
      // force reflow then re-enable transition
      void this.track.offsetWidth;
      this.track.classList.remove('is-dragging');
    }
    this.dots.forEach(function (dot, n) {
      var active = n === this.index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    }, this);
    this.playActiveVideo();
  };

  XXXKeyVisualSlider.prototype.next = function () { this.goTo(this.index + 1); };
  XXXKeyVisualSlider.prototype.prev = function () { this.goTo(this.index - 1); };

  XXXKeyVisualSlider.prototype.playActiveVideo = function () {
    this.slides.forEach(function (slide, n) {
      var vids = slide.querySelectorAll('video');
      Array.prototype.forEach.call(vids, function (v) {
        if (n === this.index) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      }, this);
    }, this);
  };

  XXXKeyVisualSlider.prototype.start = function () {
    if (!this.autoplay) return;
    this.stop();
    var self = this;
    this.timer = window.setInterval(function () { self.next(); }, this.interval);
  };
  XXXKeyVisualSlider.prototype.stop = function () {
    if (this.timer) { window.clearInterval(this.timer); this.timer = null; }
  };

  XXXKeyVisualSlider.prototype.bind = function () {
    var self = this;

    this.dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        self.goTo(parseInt(dot.getAttribute('data-index'), 10));
        self.start();
      });
    });

    // pause autoplay on hover (desktop)
    this.root.addEventListener('mouseenter', function () { self.stop(); });
    this.root.addEventListener('mouseleave', function () { self.start(); });

    // touch swipe
    var startX = 0, startY = 0, dx = 0, dragging = false;
    var THRESHOLD = 40;

    this.track.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dx = 0;
      dragging = true;
      self.stop();
      self.track.classList.add('is-dragging');
    }, { passive: true });

    this.track.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      // ignore mostly-vertical gestures (let the page scroll)
      if (Math.abs(dy) > Math.abs(dx)) return;
      var pct = (-self.index * 100) + (dx / self.root.offsetWidth * 100);
      self.track.style.transform = 'translate3d(' + pct + '%, 0, 0)';
    }, { passive: true });

    this.track.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      self.track.classList.remove('is-dragging');
      if (dx <= -THRESHOLD) self.next();
      else if (dx >= THRESHOLD) self.prev();
      else self.goTo(self.index);
      self.start();
    });
  };

  // one slider instance per pane (desktop pane + mobile pane)
  function initAll(scope) {
    var panes = (scope || document).querySelectorAll('[data-xxx-kvs-pane]');
    Array.prototype.forEach.call(panes, function (pane) {
      if (pane.__xxxKvs) return;
      pane.__xxxKvs = new XXXKeyVisualSlider(pane);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Shopify theme editor: re-init on section load, jump to selected block.
  // A block can appear in both panes; move whichever pane contains the
  // selected element to that slide.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('[data-xxx-kvs-slide]');
    var pane = e.target.closest('[data-xxx-kvs-pane]');
    if (slide && pane && pane.__xxxKvs) {
      pane.__xxxKvs.stop();
      pane.__xxxKvs.goTo(parseInt(slide.getAttribute('data-index'), 10) || 0);
    }
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var pane = e.target.closest('[data-xxx-kvs-pane]');
    if (pane && pane.__xxxKvs) pane.__xxxKvs.start();
  });
})();

/* ─── COMING SOON: 購入ボタンに発売日ラベルを保持 ────────────────
   Coming Soon商品は品切れ(在庫0)だが完売ではなく発売前。購入ボタンは
   発売日ラベル(例 "YYYY.MM.DD RELEASE")を表示し、常に非活性に保つ。
   Dawn の product-info.js はバリアント変更時 toggleSubmitButton() で
   ボタン文言を variantStrings.soldOut('SOLD OUT')に上書きするため、
   data-coming-soon-label を正として再適用する(コアJSは触らない方針)。 */
(function comingSoonButtonGuard() {
  function guard(btn) {
    var label = btn.getAttribute('data-coming-soon-label');
    if (!label) return;
    var span = btn.querySelector('span');
    if (!span) return;
    function enforce() {
      if (!btn.hasAttribute('disabled')) btn.setAttribute('disabled', 'disabled');
      if (span.textContent.trim() !== label) span.textContent = label;
    }
    enforce();
    new MutationObserver(enforce).observe(btn, {
      childList: true, subtree: true, characterData: true, attributes: true
    });
  }
  function init(scope) {
    (scope || document)
      .querySelectorAll('.product-form__submit[data-coming-soon-label]')
      .forEach(guard);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  // テーマエディタでセクション再読込された場合も再適用
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
